import React from "react";
import { Box, Divider, styled } from "@mui/material";

const BODY_FONT =
  "'Inter', -apple-system, BlinkMacSystemFont, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";

const CardRoot = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundColor: "#f2f2f2",
  borderRadius: "20px",
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  [theme.breakpoints.down("sm")]: {
    padding: "18px",
    gap: "14px",
  },
}));

const SectionLabel = styled(Box)({
  fontFamily: "monospace",
  textTransform: "uppercase",
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "18px",
  color: "#000",
});

const DescriptionText = styled(Box)({
  fontFamily: BODY_FONT,
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#000",
  whiteSpace: "pre-wrap",
});

type Props = {
  description?: string;
};

const LandDescriptionCard: React.FC<Props> = ({ description }) => {
  return (
    <CardRoot>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <SectionLabel>Description</SectionLabel>
        <Divider sx={{ borderColor: "#000", borderBottomWidth: "1px", opacity: 1 }} />
        <DescriptionText sx={{ mt: "12px" }}>
          {description && description.trim().length > 0 ? description : "No description available"}
        </DescriptionText>
      </Box>
    </CardRoot>
  );
};

export default LandDescriptionCard;
